import React from 'react';
import { Box, Typography, Grid, CardMedia } from '@mui/material';
import aboutUsImg from "../images/aboutusImage.png";
import HeadphonesIcon from '@mui/icons-material/Headphones';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

const AboutUs = () => {
    return (
        <Box sx={{ backgroundColor: '#f5f9fd', minHeight: '100vh' }}>
            {/* Header Image with Overlay Title */}
            <Box
                sx={{
                    width: '100%',
                    height: { xs: '220px', md: '400px' },
                    backgroundImage: `url('https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1950&q=80')`, // Unsplash beach photo
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    position: 'relative',
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        color: '#fff',
                        fontFamily: 'cursive',
                        fontSize: { xs: '24px', md: '48px' },
                        fontWeight: 'bold',
                        textShadow: '2px 2px 6px rgba(0,0,0,0.7)',
                    }}
                >
                    Dream Fly Holiday
                </Box>
            </Box>

            {/* Content */}
            <Box sx={{ p: {xs:2, md:5, lg:5} }}>
                <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                    About Us – <span style={{ fontWeight: 'bold' }}>Dream Fly Holiday</span>
                </Typography>

                <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem' }}>
                    Welcome to <strong>Dream Fly Holiday</strong>, where every journey is designed to create unforgettable memories!
                </Typography>

                <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem' }}>
                    DreamFLY Holiday is a tour and travel company based in Noida. We provide modified travel solution for clients all over the world. We handle our clients request with great attention concentrate on every details and help them their holidays hassle-free memorable for them.
                </Typography>

                <Grid container spacing={{xs: 4, sm:5, md:9, lg:9}}>
                    <Grid item size={{ xs: 12, sm: 5, md: 5, lg:5 }}>
                        <CardMedia component="img" sx={{ height: "400px", width: '100%' }} image={aboutUsImg} alt="" />
                    </Grid>
                    <Grid item size={{ xs: 12, sm: 7, md: 5 , lg:5}}>
                        <Typography variant="body1" paragraph sx={{ fontSize: '1.3rem', fontWeight:"bold" }}>
                            Why DreamFLY Holiday?
                        </Typography>
                        <Typography variant="body1" paragraph >
                            When we think about holiday, it means a pre-arrangement, prepaid trip for every individuals as per his/her budget. Which we easily provide.
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item size={{ xs: 2.5,   md: 2.5, lg:2.5 }}>
                                <HeadphonesIcon sx={{ color: 'white', backgroundColor: '#0e8279', fontSize: '40px', padding: '11px' }} />
                            </Grid>
                            <Grid item size={{ xs: 9.5, md: 9.5, lg:9.5 }}>
                                <Grid sx={{fontWeight:"bold"}}> Excellent service & support</Grid>
                                <Grid> DreamFLY Holiday provide hassle-free experience to the customer.</Grid>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item size={{ xs: 2.5,   md: 2.5, lg:2.5 }}>
                                <Diversity3Icon sx={{ color: 'white', backgroundColor: '#0e8279', fontSize: '40px', padding: '11px' }} />
                            </Grid>
                            <Grid item size={{ xs: 9.5, md: 9.5, lg:9.5 }}>
                                <Grid sx={{fontWeight:"bold"}}>A personalised experience</Grid>
                                <Grid>We provide customer experiences that are tailored to the consumer's individual needs.</Grid>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} >
                            <Grid item size={{ xs: 2.5,   md: 2.5, lg:2.5 }}>
                                <ShoppingCartIcon sx={{ color: 'white', backgroundColor: '#0e8279', fontSize: '40px', padding: '11px' }} />
                            </Grid>
                            <Grid item size={{ xs: 9.5, md: 9.5, lg:9.5 }}>
                                <Grid sx={{fontWeight:"bold"}}>Budget friendly deals</Grid>
                                <Grid>We give opportunity to the travelers to finding the best deals on airfare, hotels etc.</Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
                    Our wide range of services includes:
                </Typography>

                <ul style={{ fontSize: '1.1rem', paddingLeft: '1.5rem' }}>
                    <li>Tailor-made holiday packages to exotic destinations.</li>
                    <li>Expert guidance to plan the perfect itinerary.</li>
                    <li>24/7 customer support for a hassle-free experience.</li>
                </ul>
            </Box>
        </Box>
    );
};

export default AboutUs;
